import { IXeroPayment } from "@/utilities/types/Payment";
import { Text } from "rizzui";
import PaymentPrice from "./payment-price";

interface PaymentInformationProps {
  payment: IXeroPayment;
}

export default function PaymentInformation({
  payment,
}: PaymentInformationProps) {
  // Format date for display
  const formatDate = (dateString: string) => {
    const date = new Date(dateString);
    return date.toLocaleDateString("en-US", {
      year: "numeric",
      month: "long",
      day: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });
  };

  return (
    <div className="rounded-lg border border-gray-100 bg-gray-50 p-4">
      <div className="mb-4">
        <Text className="text-base font-medium text-gray-900">
          Payment Information
        </Text>
      </div>

      <div className="grid gap-3 sm:grid-cols-2">
        <div className="flex flex-col">
          <Text className="text-sm text-gray-500">Invoice ID</Text>
          <Text className="text-sm font-medium">
            {payment.xeroInvoiceID || ""}
          </Text>
        </div>
        <div className="flex flex-col">
          <Text className="text-sm text-gray-500">Package</Text>
          <Text className="text-sm font-medium">
            {payment?.package?.name || ""}
          </Text>
        </div>
        <div className="flex flex-col">
          <Text className="text-sm text-gray-500">Date</Text>
          <Text className="text-sm font-medium">
            {formatDate(payment?.createdAt)}
          </Text>
        </div>
      </div>

      <div className="my-4">
        <Text className="text-base font-medium text-gray-900">
          Payment Price
        </Text>
      </div>

      <PaymentPrice className="grid gap-3 grid-cols-1" payment={payment} />
    </div>
  );
}
